"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'userAttributes';
exports.FETCH_USER_ATTRIBUTES = exports.namespace + "/FETCH_USER_ATTRIBUTES";
//# sourceMappingURL=constants.js.map